import { LOGO_URL } from "@/lib/constants";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section bg-cream"
    >
      <div className="mx-auto max-w-6xl grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="eyebrow left">our story</span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
            A table built on{" "}
            <span className="font-script text-[hsl(var(--rose-deep))]">
              heritage
            </span>
            , hospitality, and honest food.
          </h2>
          <div className="mt-6 stitched-divider w-32" />
          <p className="mt-6 text-[hsl(var(--brown-soft))] leading-relaxed">
            Heritage Table Catering was created for people who still believe
            food should feel personal. Our menus are inspired by family
            traditions, multicultural kitchens, church gatherings, handcrafted
            desserts, and the kind of meals that bring people together.
          </p>
          <p className="mt-4 text-[hsl(var(--brown-soft))] leading-relaxed">
            We serve Central Florida families, churches, weddings, and event
            hosts with food that is warm, meaningful, and beautifully
            presented.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 text-center">
            <Stat k="Many" v="cultural traditions" />
            <Stat k="Family" v="recipe-driven menus" />
            <Stat k="Central" v="Florida service area" />
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-3 rounded-[2rem] bg-[hsl(var(--sage)/0.18)] -rotate-2" />
          <div className="absolute -inset-3 rounded-[2rem] bg-[hsl(var(--rose)/0.18)] rotate-3" />
          <div className="relative recipe-card p-8 bg-[hsl(var(--cream-deep))]">
            <img
              src={LOGO_URL}
              alt="Heritage Table Catering crest"
              className="w-full max-w-[320px] mx-auto"
            />
            <div className="mt-4 text-center">
              <div className="font-script text-2xl text-[hsl(var(--rose-deep))]">
                gather. taste. remember.
              </div>
              <div className="mt-1 text-xs tracking-[0.3em] uppercase text-[hsl(var(--sage-deep))] font-semibold">
                heritage table · central florida
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ k, v }) {
  return (
    <div className="recipe-card px-3 py-4">
      <div className="font-serif-display text-xl text-[hsl(var(--rose-deep))]">
        {k}
      </div>
      <div className="text-[11px] tracking-wider text-[hsl(var(--brown-soft))] mt-1">
        {v}
      </div>
    </div>
  );
}
